<template>
  <div id="summer">
    <div class="top">
      <div class="sun"></div>
    </div>
    <div class="bottom">
      <div class="leafs">
        <img :src="'./img/leafs.png'">
        <img :src="'./img/leafs.png'">
      </div>
    </div>
  </div>
</template>
<script>
export default {
}
</script>
